import { render, staticRenderFns } from "./GaiasGarden.vue?vue&type=template&id=48196e85&"
import script from "./GaiasGarden.vue?vue&type=script&lang=js&"
export * from "./GaiasGarden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports